import React, { createContext, useContext, useState } from 'react';
import './style.css';



// Create a context
export const StyleContext = createContext();

// Provider component that wraps your app and provides the style values
export const StyleProvider = ({ children }) => {


  const [style, setStyle] = useState({

    color1: 'rgb(39, 55, 77)',
    color2: 'rgb(82, 109, 130)',
    color3: 'rgb(157, 178, 191)',
    color4: 'rgb(221, 230, 237)',
    // color5: 'rgb(250,250,248)',
    // color6: 'rgb(4,3,2)',
    // color7: 'rgb(220,220,220)',
    // color8: 'rgb(100,100,100)',
    // color9: 'rgb(58,59,60)',
    // color10: 'rgb(40,41,42)',
    borderRadius:'10px',

    // productBGColor:'rgb(25,31,34)',

    // cardCalloutGreen: 'rgb(6, 138, 42)',
    // cardCalloutBlue: 'rgb(14, 31, 143)',
    accentGreen: "rgb(38, 166, 104)",
    darkPanel: "rgba(9, 12, 18, 0.45)",
    darkerPanel: "rgba(6, 9, 14, 0.55)",

  });

  document.body.style.backgroundColor = ('rgb(0,0,0)');
  document.body.style.color = style.textColor1;


  return (
    <StyleContext.Provider value={{ style, setStyle }}>
      {children}
    </StyleContext.Provider>
  );
};

// Custom hook to use the style context
export const useStyle = () => useContext(StyleContext);
